import _ from 'lodash';
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Fuse from 'fuse.js';
import * as actions from '../../../actions/clubActions';
import * as regActions from '../../../actions/regActions';
import { Link } from 'react-router';
import FontAwesome from 'react-fontawesome';

class ClubRegTable extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.componentWillMount = this.componentWillMount.bind(this);
    this.filterUpdate = this.filterUpdate.bind(this);
    this.getStatusObject = this.getStatusObject.bind(this);
    this.getApprovedIcon = this.getApprovedIcon.bind(this);
    this.state = {
      filter: "",
    };
  }

  componentWillMount() {
    this.props.actions.loadClubs();
    this.props.regActions.loadApprovedRegList(this.props.eventId);
  }


  filterUpdate(e) {
    let filter = e.target.value;
    this.setState({
      filter: filter
    });
  }

  getStatusObject(club) {
    let regStatusItem = _.find(this.props.approvedRegList, {club: club.id});
    return regStatusItem;
  }

  getApprovedIcon(status) {
    if (status === undefined) {
      return;
    } else if (status.approved === true) {
      return (<FontAwesome name="check" className="text-success" />);
    } else if (status.approved === false){
      return (
        <span>
          <FontAwesome name="warning" className="text-warning" />
          Venter på godkjenning
        </span>
      );
    }
  }

  getArchivedIcon(status) {
    if (status === undefined) {
      return;
    } else if (status.archived === false) {
      return (<FontAwesome name="check" className="text-success" />);
    } else if (status.archived === true){
      return (<FontAwesome name="times" className="text-danger" />);
    }
  }

  render() {
    let filteredList = this.props.clubList;
    if(this.state.filter) {
      let search = new Fuse(this.props.clubList,{
        keys: ["name",]
        });
      filteredList = search.search(this.state.filter);
    }
    return (
      <div className="row">
        <div className="col-md-12">

            <div className="page-header clearfix form-inline">
              <h2>
                {'Velg klubb '}

                <div className="pull-right">
                  <div className="input-group hidden-xs">
                    <span className="input-group-addon" id="basic-addon3">
                      <FontAwesome
                        name="search" />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      onChange={this.filterUpdate}
                      value={this.state.filter}
                      />
                  </div>
                  {' '}
                </div>
              </h2>
            </div>
            <div className="">
              <div className="hidden-sm hidden-sm hidden-md hidden-lg hidden-xl">
                <div className="input-group">
                  <span className="input-group-addon">
                    <FontAwesome
                      name="search" />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    onChange={this.filterUpdate}
                    value={this.state.filter}
                    />
                </div>
                <hr/>
              </div>
              <table className="table table-background table-bordered">
                <thead>
                  <tr>
                    <th>Klubbnavn</th>
                    <th>Arkivert</th>
                    <th>Godkjent</th>
                    <th/>
                  </tr>
                </thead>
                <tbody>
                  {filteredList.map((club, index) => {
                    let status = this.getStatusObject(club);
                    return (
                      <tr key={index}>
                        <td>
                          <h5>{club.name}</h5>
                        </td>
                        <td>
                          {this.getArchivedIcon(status)}
                        </td>
                        <td>
                          {this.getApprovedIcon(status)}
                        </td>
                        <td>
                          <Link
                            to={'/arrangement/' + this.props.eventId +
                              '/registrer/klubb/' + club.id + '/info'}
                            className="btn btn-primary pull-right">
                            Til påmelding
                          </Link>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
        </div>
      </div>
    );
  }
}

ClubRegTable.propTypes = {
  actions: PropTypes.object.isRequired,
  regActions: PropTypes.object.isRequired,
  approvedRegList: PropTypes.array,
  clubList: PropTypes.array.isRequired,
  eventId: PropTypes.string.isRequired,
  loading: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    clubList: state.clubs.clubList,
    loading: state.clubs.loadingClubs,
    approvedRegList: state.registration.approvedRegList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    regActions: bindActionCreators(regActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClubRegTable);



/** WEBPACK FOOTER **
 ** ./src/containers/events/register/ClubRegTable.js
 **/